export const REDUCER_NAME = 'organizationProfile';
